interface Config {
  apiUrl: string;
}

const development: Config = {
  // apiUrl: 'http://192.168.1.3:8000/api/v1'
  apiUrl: 'http://127.0.0.1:8001/api/v1'
};


const production: Config = {
  apiUrl: 'https://powerai-api.fly.dev/api/v1'  // fly.io backend (moved off Render 2026-08-02)
};

const config = process.env.NODE_ENV === 'production' ? production : development;

export default config; 